<section class="analogue-dialog">
  <button class="analogue-dialog__close" aria-label="Закрыть аналоги" mat-icon-button type="button" (click)="close()">
    <mat-icon>close</mat-icon>
  </button>

  <app-analogue-panel-v2 class="catalog-compact"
    [productId]="data.productId"
    [productTitle]="data.productTitle || ''"
    [dialogMode]="true"
  ></app-analogue-panel-v2>
</section>
